import styled from '@emotion/styled';

const Label = styled.div<{
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
    fontSize?: string;
    borderRadius?: string;
    fontWeight?: string;
    padding?: string;
    borderWidth?: string;
}>`
    border-radius: ${(props) => props.borderRadius || '4px'};
    background-color: ${(props) => props.backgroundColor || '#f3f3f3'};
    align-items: center;
    color: ${(props) => props.color || '#222222'};
    font-weight: ${(props) => props.fontWeight || '600'};
    padding: ${(props) => props.padding || '0.2rem 0.9rem'};
    width: fit-content;
    border: ${(props) => props.borderWidth || '1px'} solid ${(props) => props.borderColor || 'transparent'};
    font-size: ${(props) => props.fontSize || 'var(--font-medium)'};
`;

export const ColorLabel: React.FC<{
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
    fontSize?: string;
    fontWeight?: string;
    borderWidth?: string;
    borderRadius?: string;
    padding?: string;
    children: React.ReactNode;
}> = ({ color, backgroundColor, borderColor, fontSize, fontWeight, borderWidth, borderRadius, padding, children }) => {
    return (
        <Label
            color={color}
            backgroundColor={backgroundColor}
            borderColor={borderColor}
            fontSize={fontSize}
            borderRadius={borderRadius}
            fontWeight={fontWeight}
            padding={padding}
            borderWidth={borderWidth}
        >
            {children}
        </Label>
    );
};
